import { createFileRoute } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import { rules } from '~/data/rules';
import { PageSection } from '~/routes/__root';
import { langStore } from '~/store/langStore';
import { MarkdownBlock } from '~/utils/markdown';

export const Route = createFileRoute('/about/rules')({
  component: HaziRend,
});

function HaziRend() {
  const locale = useStore(langStore, s => s);
  const title = rules[locale].split('\n')[0];
  return (
    <PageSection>
      <MarkdownBlock>
        {title}
      </MarkdownBlock>
      <div className="border-2 border-orange p-5 md:p-10">
        <MarkdownBlock>
          {rules[locale].replace(title, '')}
        </MarkdownBlock>
      </div>
    </PageSection>
  );
}
